module.exports = __webpack_public_path__ + "files/014b724f65fb5482f68c8e96dabbfecc.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/food_drink-2.png
// module id = 510
// module chunks = 76